import { action } from '@ember/object';
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

export default class DashboardUrlSiteAuditDisabledController extends Controller {
  @service router;

  @action
  goToPlans() {
    this.router.transitionTo('plans', {
      queryParams: { event: 'Site Audit Upgrade CTA' },
    });
  }
}
